/* ARTMiE Marketing Hub — Back-in-Stock (Notify Me) widget.
 *
 * Activates ONLY on product pages when window.AMH_RESTOCK = { api, markets, market?, selectOos? }
 * (written by the shop metafield custom.amh_restock via snippets/amh-restock.liquid).
 *
 * Behavior:
 *   • Reads the custom PDP's #pdpVariants JSON (id → available) and the live variant id input.
 *   • When the SELECTED variant is unavailable, injects a "Notify me" button into the buy row
 *     (the add-to-cart button is already disabled by the theme for unavailable variants).
 *   • Click → modal (email + consent) → POST {api}/api/public/restock/subscribe.
 *   • selectOos: un-disables sold-out picker inputs so shoppers can SELECT a sold-out variant
 *     (the picker component's own gate honors window.AMH_RESTOCK.selectOos — see the guarded
 *     patch in component-custom-pdp-variant-picker.js).
 *   • The theme morphs the PDP section on variant change — everything re-applies via a
 *     MutationObserver + the picker's variant:change event. The modal lives on <body>,
 *     outside the morph zone.
 *
 * Texts come from {api}/api/public/restock/config (localized per market, cached in session).
 */
(function () {
  "use strict";
  var CFG = window.AMH_RESTOCK;
  if (!CFG || !CFG.api || !CFG.markets || !CFG.markets.length) return;
  if (!/\/products\//.test(location.pathname)) return;

  var MARKET = (CFG.market || CFG.markets[0] || "").toUpperCase();
  var STORE = (CFG.store || MARKET).toUpperCase();
  if (CFG.markets.indexOf(MARKET) === -1) return;

  var API = String(CFG.api).replace(/\/+$/, "");
  var TXT = null; // widget texts from the Hub (localized)
  var variants = null; // id(string) → { available, title }
  var ui = { btn: null, modal: null };
  var subscribedFor = {}; // variantId → true (this pageview)

  /* ---------- data ---------- */

  function loadVariants() {
    var el = document.getElementById("pdpVariants") || document.querySelector("script[data-pdp-variants]");
    if (!el) return null;
    try {
      var arr = JSON.parse(el.textContent);
      var map = {};
      for (var i = 0; i < arr.length; i++) map[String(arr[i].id)] = { available: !!arr[i].available, title: arr[i].title || "" };
      return map;
    } catch (e) { return null; }
  }

  function currentVariantId() {
    var input = document.getElementById("custom-pdp-variant-id") || document.querySelector('form[action*="/cart/add"] [name="id"]');
    if (input && input.value) return String(input.value);
    var m = location.search.match(/[?&]variant=(\d+)/);
    return m ? m[1] : null;
  }

  function fetchConfig(cb) {
    try {
      var cached = sessionStorage.getItem("amh_restock_cfg");
      if (cached) { var c = JSON.parse(cached); if (c && c.t > Date.now() - 600000) { cb(c.v); return; } }
    } catch (e) { /* ignore */ }
    fetch(API + "/api/public/restock/config?store=" + STORE + "&market=" + MARKET)
      .then(function (r) { return r.json(); })
      .then(function (v) {
        try { sessionStorage.setItem("amh_restock_cfg", JSON.stringify({ t: Date.now(), v: v })); } catch (e) { /* ignore */ }
        cb(v);
      })
      .catch(function () { cb(null); });
  }

  /* ---------- OOS variants selectable ---------- */

  function enableOosInputs() {
    if (!CFG.selectOos) return;
    var inputs = document.querySelectorAll(".custom-pdp-variant-picker__value--unavailable input[disabled]");
    for (var i = 0; i < inputs.length; i++) {
      inputs[i].removeAttribute("disabled");
      inputs[i].removeAttribute("aria-disabled");
    }
  }

  /* ---------- notify button ---------- */

  function ensureButton() {
    var vid = currentVariantId();
    if (!vid || !variants) return;
    var v = variants[vid];
    // Anchor: the theme's sold-out banner when it's shown (the buy row is hidden then),
    // else right after the buy row (variant switched to a sold-out one without a banner).
    var soldout = document.querySelector("[data-pdp-soldout]");
    var row = document.querySelector(".artmie-pdp__form-row");
    var anchor = (soldout && soldout.offsetParent !== null) ? soldout : row;
    var existing = document.getElementById("amh-restock-btn");
    if (!v || v.available) { if (existing) existing.remove(); return; }
    if (subscribedFor[vid]) { if (existing) { existing.textContent = TXT.confirmation.text; existing.disabled = true; } return; }
    if (existing) return;
    if (!anchor || !TXT) return;

    var btn = document.createElement("button");
    btn.type = "button";
    btn.id = "amh-restock-btn";
    btn.textContent = TXT.button.text;
    btn.setAttribute("style",
      "display:block;width:100%;max-width:440px;margin-top:10px;padding:14px 18px;border:0;border-radius:10px;cursor:pointer;" +
      "font:inherit;font-size:15px;font-weight:600;background:" + TXT.button.background + ";color:" + TXT.button.textColor + ";");
    btn.addEventListener("click", function () { openModal(vid); });
    anchor.parentNode.insertBefore(btn, anchor.nextSibling);
    ui.btn = btn;
  }

  /* ---------- modal ---------- */

  function esc(s) { return String(s == null ? "" : s).replace(/[&<>"']/g, function (c) { return { "&": "&amp;", "<": "&lt;", ">": "&gt;", '"': "&quot;", "'": "&#39;" }[c]; }); }

  function openModal(variantId) {
    closeModal();
    var v = variants[variantId] || { title: "" };
    var wrap = document.createElement("div");
    wrap.id = "amh-restock-modal";
    wrap.setAttribute("style", "position:fixed;inset:0;z-index:99999;display:flex;align-items:center;justify-content:center;background:rgba(17,24,39,.55);padding:16px;");
    wrap.innerHTML =
      '<div role="dialog" aria-modal="true" style="background:' + TXT.form.background + ";color:" + TXT.form.textColor + ';border-radius:14px;max-width:420px;width:100%;padding:22px;position:relative;box-shadow:0 20px 60px rgba(0,0,0,.3);font:inherit;">' +
      '<button type="button" data-amh-close aria-label="×" style="position:absolute;top:10px;right:12px;border:0;background:none;font-size:22px;cursor:pointer;color:inherit;opacity:.6;">×</button>' +
      '<div style="font-size:18px;font-weight:700;margin-bottom:6px;">' + esc(TXT.form.header) + "</div>" +
      (v.title && v.title !== "Default Title" ? '<div style="font-size:13px;opacity:.75;margin-bottom:6px;">' + esc(v.title) + "</div>" : "") +
      '<p style="font-size:14px;margin:0 0 12px;opacity:.9;">' + esc(TXT.form.description) + "</p>" +
      '<form data-amh-form>' +
      '<input type="text" name="hp" value="" tabindex="-1" autocomplete="off" style="position:absolute;left:-9999px;" aria-hidden="true">' +
      '<input type="email" name="email" required placeholder="email" autocomplete="email" style="width:100%;padding:12px;border:1px solid #d1d5db;border-radius:8px;font:inherit;margin-bottom:10px;box-sizing:border-box;">' +
      '<button type="submit" style="width:100%;padding:13px;border:0;border-radius:8px;cursor:pointer;font:inherit;font-weight:600;background:' + TXT.button.background + ";color:" + TXT.button.textColor + ';">' + esc(TXT.form.submitText) + "</button>" +
      '<p style="font-size:11px;opacity:.65;margin:10px 0 0;line-height:1.45;">' + esc(TXT.form.consentText) + "</p>" +
      '<div data-amh-err style="display:none;color:#b91c1c;font-size:13px;margin-top:8px;"></div>' +
      "</form>" +
      '<div data-amh-ok style="display:none;border-radius:10px;padding:12px;margin-top:4px;background:' + TXT.confirmation.background + ";color:" + TXT.confirmation.textColor + ';font-size:14px;">' +
      '<span style="color:' + TXT.confirmation.iconColor + ';margin-right:6px;">✓</span>' + esc(TXT.confirmation.text) + "</div>" +
      "</div>";
    document.body.appendChild(wrap);
    ui.modal = wrap;

    wrap.addEventListener("click", function (e) { if (e.target === wrap || e.target.hasAttribute("data-amh-close")) closeModal(); });
    document.addEventListener("keydown", onEsc);
    var form = wrap.querySelector("[data-amh-form]");
    form.addEventListener("submit", function (e) {
      e.preventDefault();
      var email = form.querySelector('[name="email"]').value.trim();
      var hp = form.querySelector('[name="hp"]').value;
      var submitBtn = form.querySelector('[type="submit"]');
      submitBtn.disabled = true;
      fetch(API + "/api/public/restock/subscribe", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ store: STORE, market: MARKET, variantId: variantId, email: email, hp: hp }),
      })
        .then(function (r) { return r.json(); })
        .then(function (d) {
          if (d && d.ok) {
            subscribedFor[variantId] = true;
            form.style.display = "none";
            wrap.querySelector("[data-amh-ok]").style.display = "block";
            var pageBtn = document.getElementById("amh-restock-btn");
            if (pageBtn) { pageBtn.textContent = TXT.confirmation.text; pageBtn.disabled = true; pageBtn.style.opacity = ".8"; }
          } else {
            submitBtn.disabled = false;
            var err = wrap.querySelector("[data-amh-err]");
            err.textContent = TXT.form.errorText || "Error — please try again.";
            err.style.display = "block";
          }
        })
        .catch(function () {
          submitBtn.disabled = false;
          var err = wrap.querySelector("[data-amh-err]");
          err.textContent = TXT.form.errorText || "Error — please try again.";
          err.style.display = "block";
        });
    });
    var emailInput = wrap.querySelector('[name="email"]');
    if (emailInput) emailInput.focus();
  }

  function onEsc(e) { if (e.key === "Escape") closeModal(); }
  function closeModal() {
    if (ui.modal) { ui.modal.remove(); ui.modal = null; }
    document.removeEventListener("keydown", onEsc);
  }

  /* ---------- wiring (morph-safe) ---------- */

  // Debounce with setTimeout, NOT requestAnimationFrame — rAF starves in background tabs
  // (and headless/prerender contexts), which would delay the button until the tab is focused.
  var applyQueued = false;
  function apply() {
    if (applyQueued) return;
    applyQueued = true;
    setTimeout(function () {
      applyQueued = false;
      variants = loadVariants() || variants;
      enableOosInputs();
      ensureButton();
    }, 40);
  }

  function init(cfg) {
    if (!cfg || !cfg.enabled || !cfg.widget) return;
    TXT = cfg.widget;
    variants = loadVariants();
    if (!variants) return; // not the custom PDP — degrade silently
    apply();
    // The picker dispatches variant:change (bubbles) — and the theme MORPHS the PDP section,
    // wiping injected nodes and re-adding disabled attrs, so also observe the section subtree.
    document.addEventListener("variant:change", apply, true);
    var section = document.querySelector(".custom-pdp-section") || document.body;
    new MutationObserver(apply).observe(section, { childList: true, subtree: true });
  }

  function start() { fetchConfig(init); }
  if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", start);
  else start();
})();
